import { LinkContainer } from 'react-router-bootstrap';
import {
  Table,
  Button,
  Container,
  Card,
  Badge,
  Stack,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { FaTrash, FaEdit } from 'react-icons/fa';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import {
  useGetUsersQuery,
  useDeleteUserMutation,
} from '../../slices/usersApiSlice';
import { Link } from 'react-router-dom';

const UserListScreen = () => {
  const { data: users = [], refetch, isLoading, error } = useGetUsersQuery();
  const [deleteUser, { isLoading: loadingDelete }] = useDeleteUserMutation();

  const deleteHandler = async (id) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      try {
        await deleteUser(id).unwrap();
        toast.success('User deleted');
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  return (
    <Container fluid="md" className="py-4">
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h4 className="mb-0">User Management</h4>
          {loadingDelete && <Loader size="sm" />}
        </Card.Header>
        <Card.Body>
          {isLoading ? (
            <Loader />
          ) : error ? (
            <Message variant="danger">{error.toString()}</Message>
          ) : (
            <Table
              striped
              hover
              responsive
              className="align-middle text-center mb-0"
            >
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Stripe CID</th>
                  <th>Used</th>
                  <th>Org</th>
                  <th>Subscription</th>
                  <th>Address</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u.id}>
                    <td className="text-muted">{u.id}</td>
                    <td>{u.name}</td>
                    <td>
                      <a href={`mailto:${u.email}`}>{u.email}</a>
                    </td>
                    <td>
                      {u.stripeCustomerId ? (
                        u.stripeCustomerId
                      ) : (
                        <span className="text-muted">—</span>
                      )}
                    </td>
                    <td>{u.currentSubscriptionUsedItems ?? 0}</td>
                    <td>
                      {u.Organization?.name || (
                        <span className="text-muted">—</span>
                      )}
                    </td>
                    <td>
                      {u.currentSubscription ? (
                        <Badge bg="success">
                          {u.currentSubscription.name}
                        </Badge>
                      ) : (
                        <Badge bg="secondary">None</Badge>
                      )}
                    </td>
                    <td>
                      {[u.postalCode, u.prefecture, u.city, u.streetAddress, u.buildingName]
                        .filter(Boolean)
                        .join(' / ') || (
                        <span className="text-muted">—</span>
                      )}
                    </td>
                    <td>
                      <Stack direction="horizontal" gap={2} className="justify-content-center">
                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit user</Tooltip>}>
                          <Button as={Link}
                                  to={`/user/${u.id}/edit`}
                                  variant="outline-primary"
                                  size="sm">
                            <FaEdit />
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Delete user</Tooltip>}
                        >
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => deleteHandler(u.id)}
                          >
                            <FaTrash />
                          </Button>
                        </OverlayTrigger>
                      </Stack>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default UserListScreen;